import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { capitalizeLetter } from "../ProjectLog/LogHelpers";
import StatusPill from "../../common/StatusPill";
import {
  COMPONENT_RUN_STATUS_LABELS,
  COMPONENT_RUN_STATUS_VARIANT,
  statusTextColorForVariant,
} from "../../../utils/statusColors";

export const renderStatus = (status, options = {}) => {
  const { asChip = false, isLatestRun = true } = options;
  const variant = isLatestRun
    ? COMPONENT_RUN_STATUS_VARIANT[status] || "neutral"
    : "neutral";

  const displayStatus = COMPONENT_RUN_STATUS_LABELS[status] || status || "";
  const label = capitalizeLetter(String(displayStatus).toLowerCase());

  if (asChip) {
    return (
      <StatusPill variant={variant} size="sm">
        {status === "INPROGRESS" && (
          <CircularProgress
            size={12}
            thickness={4}
            sx={{ color: "inherit" }}
          />
        )}
        {label}
      </StatusPill>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        color: statusTextColorForVariant(variant),
        fontWeight: "bold",
        fontSize: "13px",
      }}
    >
      {status === "INPROGRESS" && (
        <CircularProgress size={16} style={{ marginRight: "8px" }} />
      )}
      {label}
    </Box>
  );
};
